export default __webpack_public_path__ + "static/media/app.0cb7ef4a.svg";